import { USER_TYPE_KAM, isRateCardJourney } from 'common/constants/app.constants';
import { History } from 'home/view/check-feasibility/comp-generator/common-interface';

import queryString from 'query-string';
import { isOrderTypeConfirmation } from 'app-layout/utils';
import { isTMORedirect } from 'common/utils/app.utils';
import { fetchLeadHandler, validateAndFetchOrder } from './response.handler';
import { IGetLead, IGetLeadRequest } from './lead.interface';

export const getQueryParam = () => {
  const params = queryString.parse(window && window.location.search);
  return params;
};

const isUserLoggedIN = () => {
  return localStorage?.getItem('accessToken') ?? null;
};

export const handleLead = (history: History) => {
  const { platform, partyId, leadId, cartId, user, utmSource, orderId, type, auth: authToken } = getQueryParam();

  if (!isUserLoggedIN()) {
    return new Promise((_onSuccess, onError) => {
      onError('User not logged in...');
    });
  }

  const isAuthUser = platform === 'AEH' && leadId && partyId && !orderId;
  const isUserKam = user === USER_TYPE_KAM;

  // Case: Track My Order and always fetch current lead on page refresh
  if (!isRateCardJourney() && isAuthUser && (isTMORedirect || isUserKam)) {
    const request = {
      payload: {
        orderId
      } as IGetLead
    } as IGetLeadRequest;
    return fetchLeadHandler();
  }

  // order redirection from email link
  if (isOrderTypeConfirmation(type) && authToken) {
    return validateAndFetchOrder(type as string, orderId as string, authToken as string, history as History);
  }

  // create new lead scenario
  return new Promise((onSuccess, _onError) => {
    onSuccess?.('new lead scenario...');
  });
};
